import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { distinctUntilChanged, throttleTime } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class ViewportService {
	private viewportHeight$ = new BehaviorSubject<number>(window.innerHeight);

	constructor(private ngZone: NgZone) {
		this.initializeViewportListener();
	}

	private initializeViewportListener() {
		if ('visualViewport' in window) {
			const viewport = window.visualViewport;

			if (!viewport) {
				return; // Exit if visualViewport is not supported
			}

			const updateHeight = () => {
				this.ngZone.run(() => {
					console.log(viewport.height, window.innerHeight);
					this.viewportHeight$.next(viewport?.height ?? window.innerHeight);
				});
			};

			fromEvent((viewport as VisualViewport), 'resize')
				.pipe(throttleTime(100), distinctUntilChanged())
				.subscribe(updateHeight);

			fromEvent((viewport as VisualViewport), 'scroll')
				.pipe(throttleTime(100), distinctUntilChanged())
				.subscribe(updateHeight);

			// Set initial height
			updateHeight();
		}
	}

	getViewportHeight() {
		return this.viewportHeight$.asObservable();
	}
}
